import React, { useEffect, useMemo } from "react";
import { ReactComponent as ArrowLeftIcon } from "./../../images/svg/arrowLeft.svg";
import { gettext } from "../../adapter";
import LoadError from "../LoadError";
import NProgress from "../../libraries/progress";
import Loader from "../Loader";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import RawChart from "./RawChart";
import { fetchRawData } from "../../actions/rawDataActions";
import { parseRawData } from "../../utils/allStationUtils";

const RawDataDetail = ({ basePath, apiUrl }) => {
  const rawDataState = useSelector((state) => {
    return state.rawData;
  });

  const { sensor, loadError, isFetching, lastDataPoint } = useMemo(() => {
    return {
      ...rawDataState,
      ...parseRawData(rawDataState.sensor),
    };
  }, [rawDataState]);

  const { sensorId } = useParams();
  const dispatch = useDispatch();
  const { search } = useLocation();

  useEffect(() => {
    NProgress.start();
    dispatch(fetchRawData(apiUrl, sensorId));
  }, [sensorId, dispatch, apiUrl]);

  if (!sensor) {
    if (loadError) {
      NProgress.done();
      return <LoadError />;
    } else {
      return <Loader message={gettext("Loading sensor data...")} />;
    }
  }

  if (!isFetching) {
    NProgress.done();
  }

  var charts = "";
  // Only show charts if we have actual data
  if (lastDataPoint && sensor.startDate) {
    charts = (
      <RawChart apiUrl={apiUrl} station={sensor} isFetching={isFetching} dispatch={dispatch} />
    );
  }

  return (
    <div>
      <div className="l-full buttons--header">
        <h1>{sensor.name}</h1>
        <div className="buttons is-inline">
          <a href={`${basePath}/${search}`} className="button--normal">
            <ArrowLeftIcon />
            {gettext("Back to overview")}
          </a>
        </div>
      </div>
      {charts}
    </div>
  );
};

export default RawDataDetail;
